// src/pages/home/discover/components/HomeCategories.jsx
import { useNavigate } from "react-router-dom";

import useStateHandler from "@/hooks/useStateHandler";
import {
  FACET_PREFERENCE_SIGNALS,
  trackFacetPreferenceInteraction,
} from "@/services/artworkPreferenceInteraction.service";
import HomeCarouselAnalyticsService from "@/services/homeCarouselAnalytics.service";
import CategorySliderCard from "@/shared-components/cards/components/CategorySliderCard";
import { buildCategoryDestination } from "@/utils/homeCategoryRoute";
import { buildFacetPayloadFromCategory } from "@/utils/preferenceSignals";

import useCarouselImpressionTracking from "./hooks/useCarouselImpressionTracking";

import "./styles/HomeCategories.css";

export default function HomeCategories({
  categories = [],      // ej. [ { slug:"blue", name:"Blue", image:"...", type:"color" }, … ]
  title = "",
  collection_type = "",
  trackingContext = {},
}) {
  const navigate = useNavigate();
  const { state } = useStateHandler();
  const impressionRef = useCarouselImpressionTracking(trackingContext);

  return (
    <div ref={impressionRef} className="home-categories__wrapper">
      {title && <h2 className="home-title">{title}</h2>}

      <div className="home-categories__grid">
        {categories.map((cat) => (
          <div
            key={`${collection_type}:${cat.slug || cat.name || cat.subcat}`}
            className="home-categories__grid-item"
            onClick={() => {
              const destination = buildCategoryDestination(collection_type, cat);
              const facetPayload = buildFacetPayloadFromCategory({
                collectionType: collection_type,
                category: cat,
              });
              HomeCarouselAnalyticsService.trackHomeCarouselEvent(
                "carousel_item_click",
                {
                  ...trackingContext,
                  itemId: cat.slug,
                  itemKind: "category",
                  destination,
                },
                { userSession: state.user_session }
              );
              if (facetPayload) {
                trackFacetPreferenceInteraction({
                  signal: FACET_PREFERENCE_SIGNALS.CATEGORY_CARD_CLICK,
                  source: "home_category_grid",
                  facets: facetPayload,
                });
              }
              navigate(destination);
            }}
          >
            <CategorySliderCard category={cat} />
          </div>
        ))}
      </div>
    </div>
  );
}
